import { PriceInput, PriceInputProps } from '../../controls/price-input';
import { useFormContext } from '../formContext';
import FieldWrapper, { FieldWrapperProps } from './field-wrapper';
import { useController, UseControllerProps, FieldValues } from 'react-hook-form';

export interface PriceInputFieldProps<T extends FieldValues>
  extends UseControllerProps<T>,
    Omit<PriceInputProps, 'defaultValue' | 'name' | 'className'>,
    Omit<FieldWrapperProps, 'children'> {}

export const PriceInputField = <T extends FieldValues>({
  label,
  required,
  showError,
  ...props
}: PriceInputFieldProps<T>) => {
  const { readOnly } = useFormContext();
  const {
    field,
    fieldState: { error }
  } = useController(props);

  return (
    <FieldWrapper label={label} showError={showError} error={error} required={required}>
      <PriceInput error={error} {...field} autoComplete="off" {...props} disabled={readOnly || props.disabled} />
    </FieldWrapper>
  );
};
